import { useState } from "react"
import RouteList from "./RouteList/RouteList"
import RouteView from "./RouteView/RouteView"

const RoutingContent = () => {
  const [activeView, setActiveView] = useState<'list' | 'view'>('list')
  const [selectedRouteId, setSelectedRouteId] = useState<number | null>(null)
  const [newRoute, setNewRoute] = useState<boolean>(false)

  return (
    <div style={{ padding: 12 }}>
      {activeView === 'list' ? (
        <RouteList onViewRoute={(routeId, newRoute) => {
          setSelectedRouteId(routeId)
          setActiveView('view')
          setNewRoute(newRoute)
        }} />
      ) : (
        <RouteView
          routeId={selectedRouteId!}
          newRoute={newRoute}
          onBackToList={() => {
            setSelectedRouteId(null)
            setActiveView('list')
          }}
        />
      )}
    </div>
  )
}

export default RoutingContent